// extracted by mini-css-extract-plugin
export var buttonContainer = "_69-1";
export var fontSizeSelect = "_69-3";
export var formatSelect = "_69-2";
export var formats = "_69-4";
export var hidden = "_69-5";
export var icon = "_69-6";
export var select = "_69-0";